export default __webpack_public_path__ + "static/Sash-2-6e46084b40dba297a75fa3df310f0483.png";